




























































































import { defineComponent, Ref, ref } from '@vue/composition-api'

// Vuex
import { mapGetters } from 'vuex'

// componnents
import { PageHeader, IsActive } from '@/components'
import Input from '@/components/general/formComponents/Input.vue'
import { DataTable } from '@/components/table'
import FormUser from './FormUser.vue'

// Models
import { Paginator, UserInput, UserModel } from '@/models'

// services
import { UsersService } from '@/services/config'

// constants
import { ROLES_USER } from '@/constants/roles'

const USER_INIT: UserInput = {
  name: '',
  email: '',
  role_id: ROLES_USER.USER_PIECEWORK,
  is_active: true,
  password: '',
  password_confirmation: ''
}

export default defineComponent({
  name: 'ListUsers',
  components: {
    PageHeader,
    DataTable,
    IsActive,
    FormUser,
    Input
  },
  computed: {
    ...mapGetters('auth', {
      auth: 'auth'
    })
  },
  setup () {
    const title = 'Usuarios'
    const loading: Ref<boolean> = ref(false)
    const showModal: Ref<boolean> = ref(false)
    const titleModal: Ref<string> = ref('Crear usuario')
    const idEdit: Ref<number|null> = ref(null)
    const actionForm: Ref<'create'|'edit'> = ref('create')
    const userForm: Ref<UserInput> = ref({ ...USER_INIT })
    const searchBy = ref('')
    const items = [
      {
        text: 'Dashboard'
      },
      {
        text: 'Uusarios',
        active: true
      }
    ]
    const headers = [
      {
        key: 'name',
        sortable: true,
        label: 'Nombre'
      },
      {
        key: 'email',
        sortable: true,
        label: 'Correo Electrónico'
      },
      {
        key: 'role.name',
        sortable: true,
        label: 'Rol'
      },
      {
        key: 'status_text',
        sortable: true,
        label: 'Status'
      },
      {
        key: 'actions',
        sortable: false,
        label: ''
      }
    ]
    const pagination: Ref<Paginator> = ref({
      currentPage: 1,
      total: 0,
      count: 0,
      perPage: 10
    })

    const users: Ref<UserModel[]> = ref([])
    const getUsers = async () => {
      loading.value = true
      const result = await UsersService.getWithPagination(pagination.value.perPage, pagination.value.currentPage, searchBy.value)
      const p = result.pagination
      users.value = result.objects
      pagination.value = {
        currentPage: p.currentPage,
        count: p.count,
        perPage: p.perPage,
        total: p.total
      }
      loading.value = false
    }
    getUsers()

    const search = () => {
      getUsers()
    }

    const addNew = () => {
      userForm.value = { ...USER_INIT }
      showModal.value = true
      titleModal.value = 'Crear Usuario'
    }

    const hideModal = () => {
      showModal.value = false
    }

    const saveSuccess = () => {
      hideModal()
      userForm.value = { ...USER_INIT }
      getUsers()
    }

    const editItem = (item: UserModel) => {
      userForm.value = {
        name: item.name,
        email: item.email,
        role_id: item.role_id,
        is_active: item.is_active,
        password: '',
        password_confirmation: ''
      }
      showModal.value = true
      titleModal.value = 'Editar Usuario'
      actionForm.value = 'edit'
      idEdit.value = item.id
    }

    const changePage = (page: number) => {
      pagination.value.currentPage = page
      getUsers()
    }

    const changePerPage = (perPage: number) => {
      pagination.value.perPage = perPage
      pagination.value.currentPage = 1
      getUsers()
    }

    return {
      title,
      items,
      addNew,
      loading,
      headers,
      pagination,
      changePage,
      changePerPage,
      users,
      idEdit,
      actionForm,
      titleModal,
      showModal,
      editItem,
      saveSuccess,
      hideModal,
      userForm,
      search,
      searchBy
    }
  }
})
